/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService
 */

/**
 *  Request for listing content associated with a specific topic
 */

/**
 *  Response containing content associated with a specific topic and topic details
 */

/**
 *  Request for listing topics associated with a specific content item
 */

/**
 *  Response containing topics associated with a specific content item and content details
 */

/**
 *  Request for listing topics with pagination
 */

/**
 *  Response containing a page of topics
 */

/**
 *  Cursor for paginating through topics
 */

/**
 *  Error model for topic recommendations
 */

/**
 *  Request model for fetching topic recommendations
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const getTopPerformingContentRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'getTopPerformingContent',
  auth: 'app',
  fingerprint: 'uwQaN3zq88tLzlO4EWSAlLC9cfdo0l_5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTopEntitiesRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'getTopEntities',
  auth: 'app',
  fingerprint: 'SZqKFee4Pep5i8ayFDdWTg44yjABzft5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTopicRecommendationsRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'getTopicRecommendations',
  auth: 'app',
  fingerprint: '3XxtQtDETNvlBCWy_vrqsdTDHw-eq7tO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getKeywordsWithDomainInAiOverviewRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'getKeywordsWithDomainInAiOverview',
  auth: 'app',
  fingerprint: '1yJ39IVn2-k4ds050ZVKPATlUJunG3G7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getContentInAiOverviewRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'getContentInAiOverview',
  auth: 'app',
  fingerprint: 'ay3e-vBy0ZzGYOell7JpqZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEntitiesWithContentInAiOverviewRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'getEntitiesWithContentInAiOverview',
  auth: 'app',
  fingerprint: 'lyHKg0ZGBEHqwKjQnRc4hZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listTopicsRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'listTopics',
  auth: 'app',
  fingerprint: 'QDADQTXbN6ACbT7m6Mpw84wjJlDgm8HG',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listContentForTopicRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'listContentForTopic',
  auth: 'app',
  fingerprint: 'TzDX8ATfaX1KjYodlRgJLrA0FRmQq6cB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listTopicsForContentRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'listTopicsForContent',
  auth: 'app',
  fingerprint: 'uCgQ-Xt0X0kcuSKIFl-n47A0FRmQq6cB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAssociatedContentForTopicRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'updateAssociatedContentForTopic',
  auth: 'app',
  fingerprint: 'zJfR0kdlApaOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const startPopulationRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'startPopulation',
  auth: 'app',
  fingerprint: 'gfWrze10QNqJjLL-hTnYdgp6d4GVXho8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateTopicVisibilityRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'updateTopicVisibility',
  auth: 'app',
  fingerprint: 'HZ7EdQowDv2OUe2e_r4XmQZZn2cXr06J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateTopicNameRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'updateTopicName',
  auth: 'app',
  fingerprint: 'nPxrVD8sdgGOUe2e_r4XmQgvFTmVnIjq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitFeedbackRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'submitFeedback',
  auth: 'app',
  fingerprint: 'xOqbiIoCTLpxL9TbnjSCvUd8VxwRekTe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTopicFitRecommendationsRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'getTopicFitRecommendations',
  auth: 'app',
  fingerprint: 'vMT37BynED7zqygji_ASWpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const applyRecommendationsRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'applyRecommendations',
  auth: 'app',
  fingerprint: 'XwffYqbhQRLzqygji_ASWrA0FRmQq6cB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const applyAeoRecommendationsRpc = {
  serviceName: 'com.hubspot.ai.engine.optimization.rpc.AiEngineOptimizationService',
  rpcName: 'applyAeoRecommendations',
  auth: 'app',
  fingerprint: 'e_SW_0ispgSOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};